import React from "react";
import { FaFilter, FaRedo, FaSearch, FaTimes } from "react-icons/fa";

import { NOTIFICATION_CATEGORIES } from "../utils/notificationListUtils";

function NotificationFilters({
  filters,
  stats,
  refreshing,
  onChange,
  onReset,
  onRefresh,
}) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-sky-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
            <FaFilter />
            Filtres notifications
          </div>

          <h2 className="mt-3 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            Rechercher et classer les notifications
          </h2>

          <p className="mt-2 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
            Filtre par mot-clé ou par catégorie détectée automatiquement dans le
            message.
          </p>
        </div>

        <div className="grid gap-2 sm:grid-cols-2">
          <button
            type="button"
            onClick={onReset}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-bold text-slate-600 transition hover:border-red-200 hover:text-red-600 dark:border-white/10 dark:bg-white/[0.05] dark:text-white/70"
          >
            <FaTimes />
            Réinitialiser
          </button>

          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
          >
            <FaRedo className={refreshing ? "animate-spin" : ""} />
            {refreshing ? "Actualisation..." : "Actualiser"}
          </button>
        </div>
      </div>

      <div className="mt-5 grid gap-3 xl:grid-cols-[1.3fr_0.8fr_0.5fr]">
        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Recherche
          </span>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="search"
              value={filters.search}
              onChange={(event) => onChange("search", event.target.value)}
              placeholder="Rechercher dans le message..."
              className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 pl-11 pr-4 text-sm font-bold text-slate-700 outline-none transition placeholder:text-slate-400 focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
            />
          </div>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Catégorie
          </span>

          <select
            value={filters.category}
            onChange={(event) => onChange("category", event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          >
            {NOTIFICATION_CATEGORIES.map((category) => {
              const count =
                category.value === "all"
                  ? stats.total
                  : stats[category.value] || 0;

              return (
                <option key={category.value} value={category.value}>
                  {category.label} ({count})
                </option>
              );
            })}
          </select>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Tri
          </span>

          <select
            value={filters.sort}
            onChange={(event) => onChange("sort", event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          >
            <option value="recent">Plus récentes</option>
            <option value="oldest">Plus anciennes</option>
          </select>
        </label>
      </div>

      <div className="mt-4 flex gap-2 overflow-x-auto pb-1">
        {NOTIFICATION_CATEGORIES.map((category) => {
          const isActive = filters.category === category.value;
          const count =
            category.value === "all" ? stats.total : stats[category.value] || 0;

          return (
            <button
              key={category.value}
              type="button"
              onClick={() => onChange("category", category.value)}
              className={`inline-flex min-h-10 shrink-0 items-center justify-center gap-2 rounded-2xl px-4 py-2 text-xs font-bold transition ${
                isActive
                  ? "bg-blue-700 text-white shadow-lg shadow-blue-500/20"
                  : "bg-slate-100 text-slate-600 hover:bg-sky-100 hover:text-sky-700 dark:bg-white/10 dark:text-white/60 dark:hover:bg-sky-500/10 dark:hover:text-sky-200"
              }`}
            >
              {category.label}
              <span
                className={`rounded-full px-2 py-0.5 ${
                  isActive
                    ? "bg-white/15 text-white"
                    : "bg-white text-slate-500 dark:bg-slate-950 dark:text-white/50"
                }`}
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default NotificationFilters;